<template>
<div class="main two-columns">
	<div>
		<h3 style="border-bottom: 1px solid #333; margin-bottom: 1em; padding-bottom: 0.5em;">Order From National Data Center Email</h3>
		<div class="two-columns">
			<div class="email-details">
                <label>ID</label><div>{{ product_info.product_id }}</div>
                <label>UPC</label><div>{{ product_info.upc }}</div>
                <label>Manufacturer</label><div>{{ product_info.manufacturer }}</div>
                <label>Model</label><div>{{ product_info.model }}</div>
                <label>Caliber</label><div>{{ product_info.caliber }}</div>
			</div>

			<div class="email-details">
				<label>Distributor</label><div>{{ distributor.company_name }}</div>
				<label>Item Number</label><div>{{ distributor.item_number }}</div>
				<label>Cost</label><div>${{ distributor.price }}</div>
				<label>Available</label><div>{{ distributor.quantity }}</div>
				<label>Order Quantity</label><div>{{ dealerEmail.order_quantity }}</div>
			</div>
		</div>
		<div class="two-columns">
			<div class="email-details">
				<label>On Hand</label><div>{{ availability.on_hand || 'N/A' }}</div>
				<label>Current Cost</label><div>{{ availability.cost ? '$' + availability.cost : '' }}</div>
				<label>POS Price</label><div>{{ availability.price ? '$' + availability.price : '' }}</div>
				<label>Profit</label><div>{{ availability.pos_profit ? availability.pos_profit + '%' : '' }}</div>
			</div>

			<div class="email-details">
				<label>Recent Sales</label><div>{{ availability.recent_orders }}</div>
				<label>In Reorder Cart</label><div>{{ product_info.in_cart || 0 }}</div>
				<label>On Order Distributors</label><div>{{ availability.on_order_distributors || 0 }}</div>
				<label>On Purchase Order</label><div>{{ availability.on_order_po || 0 }}</div>
			</div>
		</div>

		<div class="email-controls">
			<p v-if="validateOrder == 'ok'">This order for {{ dealerEmail.order_quantity }} item{{ dealerEmail.order_quantity > 1 ? 's' : '' }} will cost ${{ $formatCurrency(dealerEmail.order_quantity * distributor.price) }}</p>
			<p v-else><b>Oops!</b> {{ validateOrder }}</p>
			<div :class="['button', validateOrder != 'ok' || submittingOrder || distributorOrderNumber ? 'grey' : 'action']" @click="submitOrder()">{{ orderMessage }}</div>
			<div class="two-columns" style="margin: 1em 0 0 0;">
				<div class="button neutral" @click="addToCart()">{{ product_info.in_cart ? 'In' : 'Add to' }} Reorder Cart</div>
				<div class="button neutral" @click="manageProduct()">Manage Product</div>
			</div>
		</div>

	</div>
    <div v-if="showEmailPreview" class="email-preview" v-html="emailContent"></div>

</div>
</template>

<script>
import Loading from '@/components/Loading.vue'
export default {
	name: 'order-from-link',
    components: {
        'loading': Loading
    },
	data() {
		return {
            loading: false,
			message: '',
			storeAdministrator: false,
			clientId: '',
			emailId: '',
			showEmailPreview: false,
			emailContent: '',
			productId: '',
			dealerEmail: {},
			distributor: {},
			product_info: {},
			availability: {},
			today: '',
			submittingOrder: false,
			orderMessage: 'Loading...',
			distributorOrderNumber: ''
		}
	},
    created() {
		if (this.$route.query.email) {
			this.emailId = this.$route.query.email
			this.getEmailData()
		} else {
			this.message = 'Email ID is missing'
		}
		let today = new Date();
		this.today = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0')
    },
	computed: {
		validateOrder() {
			if (this.message) {
				return this.message
			}
			if (this.dealerEmail.order_number) {
				return 'Distributor order already created (Order Number ' + this.dealerEmail.order_number + ').'
			}
			if (!this.dealerEmail.client_has_permission) {
				return 'This email is not valid for your store.'
			}
			if (!this.dealerEmail.user_has_permission) {
				return 'You are not authorized to place this order.'
			}
			if (this.dealerEmail.order_by_date < this.today) {
				return 'The order by date was ' + this.dealerEmail.order_by_date + '.'
			}
			if (this.distributor.quantity < this.dealerEmail.order_quantity) {
				return 'Distributor currently has insufficient availability for this order.'
			}
			return 'ok'
		}
	},
	methods: {
		getEmailData() {
			this.loading = true
			this.apiCall({ destination: 'get_item_order_from_email_data', data: { email_id: this.emailId } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.dealerEmail = obj.email
					this.productId = obj.product_id
					this.emailContent = obj.email_content
					this.showEmailPreview = true
					this.apiCall({ destination: 'get_item_product_info', data: { product_id: this.productId } }).then(obj => {
						if (obj.status == 'success') {
							this.product_info = obj.product
						}
					}).catch(err => {
						console.log(err)
					})
					this.apiCall({ destination: 'get_item_product_availability', data: { product_id: this.productId } }).then(obj => {
						if (obj.status == 'success') {
							this.availability = obj.product
							for (let i = 0; i < this.availability.distributors.length; i++) {
								if (this.availability.distributors[i]['distributor_id'] == this.dealerEmail.distributor_id) {
									this.distributor = this.availability.distributors[i]
									console.log(this.distributor)
									if (this.validateOrder == 'ok') {
										this.orderMessage = "Submit Order for " + this.dealerEmail.order_quantity + " of this item to " + this.distributor.company_name
									} else {
										this.orderMessage = "Order not eligible"
									}
									break;
								}
							}
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		addToCart(item) {
			if (this.product_info.in_cart) {
				this.$router.push('/legacy/batchordermaintenance.php')
				return false
			}
			this.apiCall({ destination: 'add_to_dealer_cart', data: { product_id: this.product_info.product_id, quantity: 1 } }).then(obj => {
				if (obj.status == 'success') {
					this.product_info.in_cart = 1
				}
			}).catch(err => {
				console.log(err)
			})
		},
		manageProduct() {
			this.$router.push('/inventory/manage-products/detail/' + this.product_info.product_id)
		},
		submitOrder() {
			if (this.validateOrder != 'ok' || this.submittingOrder || this.distributorOrderNumber) { return }
			// create and submit distributor order
			this.submittingOrder = true
			this.orderMessage = 'Submitting order...'
			let postData = {
				distributor_id: this.dealerEmail.distributor_id,
				distributor_code: this.dealerEmail.distributor,
				notes: 'From email link [' + this.emailId + ']',
				items: [{ product_id: this.product_info.product_id, quantity: this.dealerEmail.order_quantity, order_cost: this.distributor.price, available: this.distributor.quantity }],
				submit_on_create: false // TODO: true when done debugging!
			}
			this.apiCall({ destination: 'create_distributor_order', data: postData }).then(obj => {
				this.submittingOrder = false
				this.orderMessage = obj.message
				if (obj.status == 'success') {
					this.distributorOrderNumber = obj.order_number
				}
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.email-details {
	display: grid;
	grid-template-columns: 10em 1fr;
	grid-gap: .5em;
	margin: 0 0 2em 2em;
}

.email-controls {
	p {
		font-size: 1.25em; text-align: center; margin: 2em 0 1em 0;
	}
	.button { width: 100%; }
}

.email-preview {
    .email-preview-inner {
	}
    .email-preview-controls {
        border-top: 1px solid #ccc;
        background-color: #e4e4e4;
        padding: 0.5em;
    }
    .email-preview-content {
        height: calc(100% - 3.5em);
        overflow-y: scroll;
        padding: 0 1em 1em 1em;
    }
    .email-preview-heading {
        margin: 0 0 1em 0;
        padding: 0.25em 0.5em;
        font-size: 1.5em;
        background-color: #333;
        color: #fff;
        text-align: center;
    }
    .email-preview-meta {
        display: grid;
        grid-template-columns: 5em 1fr;
        grid-gap: 1em;
        margin: 0 0 1em 0;
        padding: 0 0 1em 0;
        border-bottom: 1px solid #ccc;
    }
    .email-preview-message {
        font-size: 1.1em;
    }
    .email-preview-product-details {
        padding: 1em 2em 1em 2em;
        margin: 1em 0 0 0;
        border-top: 1px solid #ccc;
        h1 { text-align: center; font-size: 2em; margin: 0 0 1em 0; }
    }
    .email-preview-product-meta {
        display: grid;
        grid-template-columns: 2fr 2fr 1fr;
        margin: 2em 3em;
    }
    .email-preview-order-button {
        //margin: 0 3em;
		width: 100%;
    }
    .email-preview-footnote {
        font-size: 0.9em;
        color: #666;
        margin: 1em 0 0 0;
        padding: 1em 0;
        border-top: 1px solid #ccc;
    }
}
</style>
